import {
  Text,
  TextAlignment,
  TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import styled from 'styled-components';

// Define the styled component for the span
interface BodyTextProps {
  color?: string;
  weight?: string;
  margin?: string;
  padding?: string;
  align?: TextAlignment;
  size?: string;
}

const StyledSpan = styled.span<BodyTextProps>`
  font-family: var(--font-family-text, vw-text);
  color: ${(props) => props.color || 'white'};
  font-weight: ${(props) => props.weight || '300'};
  font-size: ${(props) => props.size || '16px'};
  line-height: 24px;
  margin: ${(props) => props.margin || '0'};
  padding: ${(props) => props.padding || '0'};
  @media (min-width: 1200px) {
    font-size: ${(props) => props.size || '20px'};
    line-height: 30px;
  }
`;

const BodyText: React.FC<BodyTextProps> = ({
  children,
  color,
  weight,
  margin,
  padding,
  size,
  align = TextAlignment.center,
}) => {
  return (
    <Text textAlign={align} appearance={TokenTextAppearance.copy200}>
      <StyledSpan
        size={size}
        weight={weight}
        color={color}
        margin={margin}
        padding={padding}
      >
        {children}
      </StyledSpan>
    </Text>
  );
};

export default BodyText;
